export enum siteRoutes {
  Home = "/",
  About = "/about",
  Products = "/products",
  Categories = "/categories",
  Projects = "/projects",
  CaseStudies = "/projects/case-studies",
  ElevatedTroughing = "/projects/elevated-troughing",
  Cart = "/cart",
  Capabilities = "/capabilities",
  Contact = "/contact",
}
